// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics'; // Utilise si tu prévois d'utiliser Google Analytics
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID, // Assure-toi d'avoir configuré cela si tu l'utilises
};

const isFirebaseConfigured =
  firebaseConfig.apiKey &&
  firebaseConfig.authDomain &&
  firebaseConfig.projectId &&
  firebaseConfig.storageBucket &&
  firebaseConfig.messagingSenderId &&
  firebaseConfig.appId;

let app = null;
let auth = null;
let provider = null;
let db = null;
let analytics = null;

if (isFirebaseConfigured) {
  // Initialize Firebase
  app = initializeApp(firebaseConfig);

  // Initialize Firebase Authentication and get a reference to the service
  auth = getAuth(app);

  // Initialize Google Auth Provider
  provider = new GoogleAuthProvider();

  // Initialize Firestore and get a reference to the service
  db = getFirestore(app);

  // Si tu utilises Google Analytics, initialise-le ici
  analytics = getAnalytics(app);
} else {
  console.warn(
    'Firebase configuration is missing or incomplete. Firebase services will not be initialized.'
  );
}

export { auth, provider, db, analytics }; // Exporte les services pour les utiliser ailleurs dans l'application

// Type guards pour vérifier si Firebase est initialisé
export const isFirebaseInitialized = () => {
  return auth !== null && db !== null;
};
